<template>
  <div class="min-h-screen">
    <!-- 桌面端显示区域 -->
    <div class="hidden lg:block">
      <!-- 英雄区 -->
      <HeroSection @open-register-modal="$emit('open-register-modal')" />
      
      <!-- 统计数据 -->
      <StatsSection />
      
      <!-- 课程培训模块 -->
      <CoursesSection />
      
      <!-- 就业创业模块 -->
      <JobsSection />
      
      <!-- 证书鉴别模块 -->
      <CertificateSection />
      
      <!-- 人才入库模块 -->
      <TalentSection @open-talent-modal="$emit('open-talent-modal')" />
      
      <!-- 证书考试模块 -->
      <ExamsSection />
      
      <!-- 用户注册引导 -->
      <RegisterSection 
        @open-register-modal="$emit('open-register-modal')"
        @open-login-modal="$emit('open-login-modal')"
      />
    </div>

    <!-- 移动端和平板显示区域 -->
    <div class="lg:hidden">
      <MobileHomeSection 
        @open-register-modal="$emit('open-register-modal')"
        @open-login-modal="$emit('open-login-modal')"
      />
    </div>
  </div>
</template>

<script>
import HeroSection from '@/components/HeroSection.vue'
import StatsSection from '@/components/StatsSection.vue'
import CoursesSection from '@/components/CoursesSection.vue'
import JobsSection from '@/components/JobsSection.vue'
import CertificateSection from '@/components/CertificateSection.vue'
import TalentSection from '@/components/TalentSection.vue'
import ExamsSection from '@/components/ExamsSection.vue'
import RegisterSection from '@/components/RegisterSection.vue'
import MobileHomeSection from '@/components/MobileHomeSection.vue'

export default {
  name: 'HomeView',
  components: {
    HeroSection,
    StatsSection,
    CoursesSection,
    JobsSection,
    CertificateSection,
    TalentSection,
    ExamsSection,
    RegisterSection,
    MobileHomeSection
  },
  mounted() {
    // 页面加载完成后的动画效果
    this.initScrollAnimations()
  },
  methods: {
    initScrollAnimations() {
      const sections = document.querySelectorAll('section')
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in')
            observer.unobserve(entry.target)
          }
        })
      }, { threshold: 0.1 })

      sections.forEach(section => {
        observer.observe(section)
      })
    }
  }
}
</script>
